import { createNamedWrapperReducer, isActionRelated } from '@core/utils/state';
import {
    WORKPLACE_VIEWED_SET,
    WORKPLACES_FETCH
} from '../action-types';
import { IEntitiesState } from '../shared/entities/entities-state';
import { IWorkplacesState, initialWorkplacesState } from './workplaces-state';
import { GROUP_WORKPLACE } from '../state-groups';
import { reducer as listReducer } from '../shared/list/reducer';

export function reducer(state = initialWorkplacesState(), action: any, entitySlice: IEntitiesState): IWorkplacesState {
    
    switch (action.type) {

        case WORKPLACES_FETCH:

            return {
                ...state,
                workplaces: {
                    ...state.workplaces,
                    isFetching: true
                }
            };

        case WORKPLACE_VIEWED_SET:
            return {
                ...state,
                viewedWorkplaceId: action.payload.workplaceId
            };

        default:
            let nextState: IWorkplacesState = state;

            if (isActionRelated(action, [GROUP_WORKPLACE])) {
                nextState = {
                    ...state,
                    workplaces: createNamedWrapperReducer(
                        listReducer,
                        GROUP_WORKPLACE
                    )(state.workplaces, action, entitySlice.entities)
                };
            }

            return nextState;
    }
}